import { Box, Typography, useTheme } from "@mui/material";
import { AiHomeIcon } from "components";
import type { ReactNode } from "react";

const AI_BORDER_GRADIENT =
  "linear-gradient(90deg, #4D25ED, #874FFF, #FF96E2, #ED25C1, #874FFF, #4D25ED)";

type AiBannerShellProps = {
  message: string;
  children?: ReactNode;
};

export const AiBannerShell = ({ message, children }: AiBannerShellProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: "9px",
        padding: "1px",
        background: AI_BORDER_GRADIENT,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "0px 8px",
          minHeight: "32px",
          borderRadius: "8px",
          backgroundColor: theme.palette.neutral.main,
        }}
      >
        <AiHomeIcon
          sx={{ width: 16, height: 16, color: theme.palette.lightBg.high }}
        />
        <Typography
          variant="body-small"
          noWrap
          sx={{ color: theme.palette.lightBg.high }}
        >
          {message}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};
